import { render, staticRenderFns } from "./SkuAbandonModal.vue?vue&type=template&id=fad670f2&scoped=true&"
import script from "./SkuAbandonModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SkuAbandonModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad670f2",
  null
  
)

export default component.exports